import { FC, useState } from 'react';
import type { TableBlock as TableBlockType } from '@/types/blocks';
import { Text } from '@/components/Typography';
import { TableDrawer } from './TableDrawer';
import { formatCompactNumber } from '@/utils/formatCompactNumber';

export const TableBlock: FC<{ block: TableBlockType }> = ({ block }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        {block.title ? (
          <Text variant="text-md-bold" className="text-grey-black dark:text-grey-main-dark">
            {block.title}
          </Text>
        ) : (
          <span />
        )}
        <button
          onClick={() => setDrawerOpen(true)}
          className="p-1.5 rounded-md hover:bg-peach transition-colors text-grey-medium hover:text-grey-black dark:hover:bg-grey-sky-dark"
          aria-label="Expand table"
          title="Expand table"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 3 21 3 21 9" />
            <polyline points="9 21 3 21 3 15" />
            <line x1="21" y1="3" x2="14" y2="10" />
            <line x1="3" y1="21" x2="10" y2="14" />
          </svg>
        </button>
      </div>

      <div className="relative">
        <div className="overflow-x-auto rounded-lg border border-peach-1 dark:border-grey-plain-dark">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-peach dark:bg-grey-sky-dark">
                {block.columns.map((col, i) => (
                  <th
                    key={i}
                    className="px-4 py-3 text-left font-medium text-grey-black dark:text-grey-main-dark whitespace-nowrap"
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {block.rows.map((row, ri) => (
                <tr
                  key={ri}
                  className="border-t border-peach-1 dark:border-grey-plain-dark even:bg-grey-light dark:even:bg-grey-sky-dark"
                >
                  {row.map((cell, ci) => (
                    <td
                      key={ci}
                      className="px-4 py-3 text-grey-main dark:text-grey-medium-dark whitespace-nowrap"
                    >
                      {formatCompactNumber(cell)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* fade hint: indicates content overflows to the right */}
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 rounded-r-lg bg-gradient-to-r from-transparent to-white dark:to-grey-sky-dark" />
      </div>

      <TableDrawer block={block} open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </div>
  );
};
